module.exports = __webpack_public_path__ + "static/media/ed-workplace.75ba2f15.png";